var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IdentityFields',{attrs:{"label":_vm.$translateLabel(_vm.field.label, _vm.field.name),"field":_vm.field,"disabled":_vm.field.protected,"page":_vm.page,"store":_vm.$store,"context":_vm.context,"translator":_vm.$t},on:{"error":_vm.fieldError},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }